/**
 * Sales Order DocType-specific translations.
 * Key: `Sales Order:${fieldname}`
 * Value: { en: string, th: string }
 */
export const salesOrderTranslations: Record<string, { en: string; th: string }> = {
  // Order Overview fields
  "Sales Order:name": { en: "Order ID", th: "รหัสคำสั่งซื้อ" },
  "Sales Order:status": { en: "Status", th: "สถานะ" },
  "Sales Order:transaction_date": { en: "Order Date", th: "วันที่สั่งซื้อ" },
  "Sales Order:delivery_date": { en: "Delivery Date", th: "วันที่จัดส่ง" },
  "Sales Order:order_type": { en: "Order Type", th: "ประเภทคำสั่งซื้อ" },
  "Sales Order:company": { en: "Company", th: "บริษัท" },
  "Sales Order:currency": { en: "Currency", th: "สกุลเงิน" },
  
  // Customer fields
  "Sales Order:customer": { en: "Customer", th: "ลูกค้า" },
  "Sales Order:customer_name": { en: "Customer Name", th: "ชื่อลูกค้า" },
  "Sales Order:customer_group": { en: "Customer Group", th: "กลุ่มลูกค้า" },
  "Sales Order:territory": { en: "Territory", th: "เขต" },
  "Sales Order:po_no": { en: "PO Number", th: "เลขที่ PO" },
  
  // Totals fields
  "Sales Order:total_qty": { en: "Total Quantity", th: "จำนวนรวม" },
  "Sales Order:net_total": { en: "Net Total", th: "ยอดรวมสุทธิ" },
  "Sales Order:total_taxes_and_charges": { en: "Taxes & Charges", th: "ภาษีและค่าธรรมเนียม" },
  "Sales Order:grand_total": { en: "Grand Total", th: "ยอดรวมทั้งสิ้น" },
  "Sales Order:rounded_total": { en: "Rounded Total", th: "ยอดรวมปัดเศษ" },
  "Sales Order:in_words": { en: "Amount in Words", th: "จำนวนเป็นตัวอักษร" },
  
  // Discount fields
  "Sales Order:discount_amount": { en: "Discount Amount", th: "จำนวนส่วนลด" },
  "Sales Order:discount_percentage": { en: "Discount %", th: "ส่วนลด %" },
  "Sales Order:additional_discount_amount": { en: "Additional Discount", th: "ส่วนลดเพิ่มเติม" },
  "Sales Order:additional_discount_percentage": { en: "Additional Discount %", th: "ส่วนลดเพิ่มเติม %" },
  "Sales Order:apply_discount_on": { en: "Apply Discount On", th: "ใช้ส่วนลดกับ" },
  
  // Status Summary fields
  "Sales Order:delivery_status": { en: "Delivery Status", th: "สถานะการจัดส่ง" },
  "Sales Order:per_delivered": { en: "% Delivered", th: "% จัดส่งแล้ว" },
  "Sales Order:per_billed": { en: "% Billed", th: "% เรียกเก็บแล้ว" },
  "Sales Order:per_picked": { en: "% Picked", th: "% เตรียมแล้ว" },
  
  // Currency & Price List fields
  "Sales Order:price_list": { en: "Price List", th: "รายการราคา" },
  "Sales Order:selling_price_list": { en: "Selling Price List", th: "รายการราคาขาย" },
  "Sales Order:plc_conversion_rate": { en: "Price List Conversion Rate", th: "อัตราแลกเปลี่ยนรายการราคา" },
  
  // Shipping & Fulfillment fields
  "Sales Order:set_warehouse": { en: "Warehouse", th: "คลังสินค้า" },
  
  // Address & Contact fields
  "Sales Order:contact_person": { en: "Contact Person", th: "ผู้ติดต่อ" },
  "Sales Order:contact_display": { en: "Contact", th: "ติดต่อ" },
  "Sales Order:contact_email": { en: "Email", th: "อีเมล" },
  "Sales Order:contact_mobile": { en: "Mobile", th: "มือถือ" },
  "Sales Order:contact_phone": { en: "Phone", th: "โทรศัพท์" },
  
  // Taxes & Charges fields
  "Sales Order:taxes_and_charges": { en: "Sales Taxes and Charges Template", th: "เทมเพลตภาษีและค่าธรรมเนียมการขาย" },
  "Sales Order:tax_category": { en: "Tax Category", th: "หมวดหมู่ภาษี" },
  "Sales Order:taxes": { en: "Sales Taxes and Charges", th: "ภาษีและค่าธรรมเนียมการขาย" },
  "Sales Order:included_in_print_rate": { en: "Price Includes Tax (VAT)", th: "ราคารวมภาษี (VAT)" },

  // Shipping & Incoterm fields
  "Sales Order:shipping_rule": { en: "Shipping Rule", th: "กฎการจัดส่ง" },
  "Sales Order:incoterm": { en: "Incoterm", th: "เงื่อนไขการค้าระหว่างประเทศ" },
  "Sales Order:named_place": { en: "Named Place", th: "สถานที่ที่ระบุ" },

  // Terms fields
  "Sales Order:payment_terms_template": { en: "Payment Terms Template", th: "เทมเพลตเงื่อนไขการชำระเงิน" },
  "Sales Order:payment_terms": { en: "Payment Terms", th: "เงื่อนไขการชำระเงิน" },
  "Sales Order:tc_name": { en: "Terms & Conditions", th: "ข้อกำหนดและเงื่อนไข" },
  "Sales Order:terms": { en: "Terms", th: "เงื่อนไข" },
  
  // Commission fields
  "Sales Order:amount_eligible_for_commission": { en: "Amount Eligible for Commission", th: "จำนวนที่ได้รับค่าคอมมิชชั่น" },
  "Sales Order:commission_rate": { en: "Commission Rate", th: "อัตราค่าคอมมิชชั่น" },
  "Sales Order:total_commission": { en: "Total Commission", th: "ค่าคอมมิชชั่นรวม" },
  
  // More Info fields
  "Sales Order:campaign": { en: "Campaign", th: "แคมเปญ" },
  "Sales Order:source": { en: "Source", th: "แหล่งที่มา" },
  "Sales Order:po_date": { en: "PO Date", th: "วันที่ PO" },
  "Sales Order:amended_from": { en: "Amended From", th: "แก้ไขจาก" },
};

